{
  "name": "client.realguest.checkin",
  "version": "2.0.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "verify:amplify": "node scripts/verify-amplify.mjs",
    "e2e": "playwright test delta-sync",
    "e2e:load": "playwright test load-multidevice",
    "e2e:race": "playwright test race-guards",
    "e2e:all": "playwright test",
    "e2e:stress": "playwright test --project=stress"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.0",
    "@angular/cdk": "^21.2.0",
    "@angular/cdk-experimental": "^21.2.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/material": "^21.2.0",
    "@angular/material-luxon-adapter": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-formly/material": "^7.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@rg/shared-ng": "file:../shared-ng/rg-shared-ng-0.0.0.tgz",
    "@types/luxon": "^3.6.2",
    "@uiowa/digit-only": "^3.2.1",
    "angularx-qrcode": "^21.0.4",
    "aws-amplify": "^6.18.0",
    "capacitor-plugin-safe-area": "^5.0.0",
    "google-libphonenumber": "^3.2.42",
    "intl-tel-input": "^21.2.8",
    "luxon": "^3.7.1",
    "ngx-scanner-qrcode": "^1.7.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.0",
    "@angular/cli": "^21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.0.0",
    "@ngx-formly/schematics": "^6.3.12",
    "@playwright/test": "^1.61.0",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/pngjs": "^6.0.5",
    "@types/yauzl": "^3.4.0",
    "autoprefixer": "^10.4.21",
    "jsdom": "^29.1.1",
    "pngjs": "^5.0.0",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.3",
    "vitest": "^4.1.7",
    "yauzl": "^2.10.0"
  }
}
